import { render, staticRenderFns } from "./select-task-type-task.vue?vue&type=template&id=01c5708a&"
import script from "./select-task-type-task.vue?vue&type=script&lang=js&"
export * from "./select-task-type-task.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports